export const examCategoryOptions = [
  {
    value: "DHA - Dubai Health Authority",
    label: "DHA - Dubai Health Authority",
  },
  {
    value: "SCFHS - Saudi Commission for Health Specialties",
    label: "SCFHS - Saudi Commission for Health Specialties",
  },
  {
    value: "DHP - Department of Healthcare Professions Qatar",
    label: "DHP - Department of Healthcare Professions Qatar",
  },
  {
    value: "NHRA - National Health Regulatory Authority Bahrain",
    label: "NHRA - National Health Regulatory Authority Bahrain",
  },
  {
    value: "MOHKW - Ministry of Health Kuwait",
    label: "MOHKW - Ministry of Health Kuwait",
  },
  {
    value: "EMOH - Emirates Ministry of Health Dubai",
    label: "EMOH - Emirates Ministry of Health Dubai",
  },
];

export const examNamesByCategory = {
  "DHA - Dubai Health Authority": {
    "Physicians": [
      "Anatomic Pathology",
      "Anesthesia",
      "Cardiology",
      "Community Medicine",
      "Clinical Pathology",
      "Critical Care Medicine",
      "Dermatology",
      "Diagnostic Radiology",
      "Emergency Medicine",
      "Endocrinology",
      "Family Medicine",
      "Forensic Medicine",
      "Gastroenterology",
      "General Practice",
      "General Surgery",
      "Hematopathology",
      "Internal Medicine",
      "Medical Microbiology",
      "Nephrology",
      "Neurology",
      "Neurosurgery",
      "Obstetrics & Gynecology",
      "Ophthalmology",
      "Orthopedic Surgery",
      "Otolaryngology",
      "Pediatrics",
      "Pediatric Surgery",
      "Physical Medicine & Rehabilitation",
      "Plastic Surgery",
      "Psychiatry",
      "Public Health Medicine",
      "Public Health & Preventive Medicine",
      "Pulmonary Diseases",
      "Radiology",
      "Rheumatology",
      "Sports Medicine",
      "Urology",
      "Vascular Surgery"
    ],
    "Dentists": [
      "Endodontics",
      "General Dentistry",
      "Implantology",
      "Oral Surgery",
      "Oral and Maxillofacial Surgery",
      "Orthodontics",
      "Pediatric Dentistry",
      "Periodontics",
      "Prosthodontics",
      "Restorative Dentistry"
    ],
    "Nursing": [
      "Registered Nurse",
      "Assistant Nurse",
      "Assistant Midwife",
      "Registered Midwife"
    ],
    "Allied Health": [
      "Aesthetician / Beauty Therapist",
      "Anesthesia Technician",
      "Anesthesia Technologist",
      "Audiologist",
      "Audiology Assistant",
      "Cardiac Perfusionist",
      "Clinical Biochemistry – Clinical Scientist",
      "Clinical Biochemistry Technologist",
      "Clinical Dietitian",
      "Clinical Pharmacy",
      "Clinical Psychology",
      "Central Sterile Services (CSS) Aide",
      "Central Sterile Services (CSS) Technician",
      "Dental Assistant",
      "Dental Hygienist",
      "Dental Lab Aide",
      "Dental Lab Technician",
      "Dialysis Technologist",
      "Dialysis Technician",
      "ECG Technician",
      "Hematology Technologist",
      "Hematology – Clinical Scientist",
      "Massage Therapist",
      "Medical Microbiology – Clinical Scientist",
      "Medical Microbiology Technologist",
      "Medical Laboratory Technician",
      "Medical Laboratory Technologist",
      "Nutritionist",
      "Occupational Therapist",
      "Occupational Therapy Technician",
      "Optometrist",
      "Pharmacist",
      "Pharmacy Technician",
      "Prosthetics & Orthotics Technologist",
      "Prosthetics & Orthotics Technician",
      "Physiotherapist",
      "Physiotherapy Technician",
      "Radiographer",
      "Radiography Technician",
      "Respiratory Technician",
      "Respiratory Therapist"
    ]
  },
  "SCFHS - Saudi Commission for Health Specialties": {
    "Nursing": [
      "Saudi Nursing Licensing Examination",
      "Midwifery",
      "Healthcare Nursing Assistant Examination",
      "Nursing Technician"
    ],
    "Physicians": [
      "Saudi Medical Licensing Examination",
      "Saudi Psychology Licensing Examination - Arabic",
      "Saudi Public Health Licensing Examination",
      "Internal Medicine",
      "Pediatrics",
      "Saudi Respiratory Care Licensing Examination",
      "Obstetrics and Gynecology",
      "Saudi Clinical Nutrition Licensing Examination",
      "General Surgery",
      "Dermatology",
      "Family Medicine",
      "Orthopedics",
      "Anesthesia",
      "Emergency Medicine",
      "Otorhinolaryngology",
      "Ophthalmology",
      "Endodontist",
      "Periodontics",
      "Oral and Maxillofacial Surgery",
      "Urology",
      "Psychiatry",
      "Plastic Surgery",
      "Gastroenterology",
      "Physiotherapy Assistant",
      "Preventive Medicine",
      "Neurology",
      "Nephrology",
      "Pulmonology",
      "Clinical Pathology ",
      "Medical Records - Arabic",
      "Neurosurgery",
      "Occupational Therapist",
      "Pediatric Surgery",
      "Saudi License for Psychology - English",
      "Vascular Surgery",
      "Rehabilitation Medicine",
      "Rheumatology",
      "Anatomical Pathology",
      "Hematology Laboratory",
      "Intensive Care Medicine",
      "Cardiology",
      "Medical Assistant - Arabic",
      "Cardiovascular Perfusion",
      "Biomedical Technologist",
      "Endocrinology",
      "Cardiothoracic Surgery",
      "Medical Microbiology",
      "Forensic Medicine Specialist"
    ],
    "Pharmacy": [
      "Saudi Pharmacy Licensing Examination"
    ],
    "Dentists": [
      "Saudi Dental Licensing Bank",
      "Orthodontics",
      "Dental Lab Technologist",
      "Prosthodontics",
      "Pediatric Dentistry",
      "Dental Hygienist",
      "Oral Surgery"
    ],
    "Allied Health": [
      "Saudi Laboratory Specialist Licensure Exam",
      "Saudi Radiologic Technologist Licensure Exam",
      "Diagnostic Radiology",
      "Microbiology Laboratory",
      "Clinical Biochemistry Laboratory",
      "Biochemistry Technician",
      "Orthotics and Prosthetics Specialist",
      "Orthotics and Prosthetics Technician"
    ]
  },
  "DHP - Department of Healthcare Professions Qatar": {
    "Physicians": [
      "Anesthesia (ANAES)",
      "Cardiology (CRDIO)",
      "Clinical pathology (CPATH)",
      "Critical Care Medicine (ICU)",
      "Community Medicine (COMED)",
      "Dermatology (DERM)",
      "Emergency Medicine (EMED)",
      "Endocrinology (ENDOC)",
      "Family Medicine (FAMME)",
      "Forensic Medicine (FRMED)",
      "Gastroenterology (GSTRO)",
      "General Practitioner (GENPR)",
      "General Surgery (GENSU)",
      "Hematology and Oncology (HMONC)",
      "Internal Medicine (INTME)",
      "Medical Microbiology (MICRO)",
      "Nephrology (NEPH)",
      "Neurology (NROLO)",
      "Neurosurgery (NEURO)",
      "Obstetrics and Gynecology (OBGYN)",
      "Ophthalmology (OPHTH)",
      "Orthopedic Surgery (ORTHO)",
      "Otorhinolaryngology (ENT)",
      "Pediatrics (PEDS)",
      "Pediatric Surgery (PDSG)",
      "Physical Medicine and Rehabilitation (PHYME)",
      "Physiotherapist (PHYSP)",
      "Plastic Surgery (PLASU)",
      "Psychiatry (PSYCH)",
      "Pulmonary (PULM)",
      "Rheumatology (RHEUM)",
      "Sports Medicine (SPMED)",
      "The Dietician Exam (DIETT)",
      "Urology (UROLO)"
    ],
    "Dentists": [
      "Dental Assistant (DASST)",
      "Dental Hygiene Tech (DHTCH)",
      "Dental Lab Tech (DLT)",
      "General Dentist (GENDE)"
    ],
    "Nursing": [

      "Registered General Nurse (NSPEC)",
      "Registered Midwife (MIDWI)"
    ],
    "Allied Health": [
      "Basic Paramedic (BPARA)",
      "Paramedic (PARAM)",
      "Lab Technician (LABTE)",
      "Lab Technologists (LABTO)",
      "Pharmacist (PHOLO)",
      "Diagnostic Radiology (RADDR)",
      "Radiography Technologist (RADSP)",
      "Radiology Technician (RAD)"
    ]
  },
  "NHRA - National Health Regulatory Authority Bahrain": {
    "Nursing": [
      "Ambulance Nurse",
      "General Nurse Intermediate",
      "Paramedic",
      "Midwife"
    ],
    "Technician": [
      "Anesthesia Technician",
      "Audiology Technician",
      "CSS Technician",
      "Dental Lab Technician",
      "Dialysis Technician",
      "Nutrition Technician",
      "ECG Technician",
      "Emergency Medical Technician (EMT) - Basic",
      "Emergency Medical Technician (EMT)",
      "Medical Laboratory Technician",
      "Medical Laboratory Technologist",
      "Nuclear Medicine Technologist",
      "Occupational Therapy Technician",
      "Pharmacy Technician",
      "Physiotherapy Technician",
      "Prosthetics & Orthotics Technician",
      "Radiologic Technician",
      "Respiratory Therapy Technician",
      "Phlebotomist",
      "Optometry Technician",
      "Radiologic Technologist"
    ],
    "Physicians": [
      "Audiologist",
      "CSS Aide",
      "Dietician",
      "Nutritionist",
      "Medical Laboratory Specialty Title",
      "Medical Practitioner",
      "Occupation Therapist",
      "Optometrist",
      "Pharmacist",
      "Physiotherapist",
      "Prosthetist/Orthotist",
      "Psychologist",
      "Psychometrist",
      "Respiratory Therapist"
    ],
    "Dental": [
      "Dental Assistant",
      "Dental Hygienist",
      "Dental Practitioner"
    ]
  },
  "MOHKW - Ministry of Health Kuwait": {
    "Nursing": [
      "Assistant Nurse",
      "Registered Nurse"
    ],
    "Dentists": [
      "General Dentistry"
    ],
    "Allied Health": [
      "Lab Technician",
      "Radiology Specialist (Radiology for Bachelor)",
      "Radiology for Diploma",
      "Diagnostic Radiology for Senior",
      "Diagnostic Radiology for Registrar"
    ],
    "Physicians": [
      "General Practitioner",
      "Specialist Obstetrics & Gynecology",
      "Anesthesia Technician",
      "Anesthesia for Registrar",
      "Pediatrics For Registrar",
      "Internal Medicine for Registrar",
      "Physiotherapist",
      "Dermatology for Registrar",
      "Ophthalmology for Registrar",
      "ENT for Registrar",
      "Emergency Medicine For Registrar",
      "Intensive Care for Registrar",
      "Pediatrics for Senior",
      "Internal Medicine for Senior",
      "Dermatology for Senior",
      "Ophthalmology for Senior",
      "ENT for Senior",
      "Intensive Care for Senior",
      "Anesthesia for Senior",
      "Obstetrics and Gynecology for Senior",
      "Emergency Medicine for Senior",
      "Cardiology for Registrar",
      "Nephrology for Registrar",
      "Family Medicine for Registrar",
      "Orthopaedics for Registrar",
      "Cardiology for Senior",
      "Nephrology for Senior",
      "Family Medicine for Senior",
      "Orthopaedics for Senior",
      "Psychiatry for Registrar",
      "Pulmonology for Registrar",
      "Gastroenterology for Registrar",
      "Neurology For Registrar",
      "Psychiatry for Senior",
      "Pulmonology for Senior",
      "Gastroenterology for Senior",
      "Neurology For Senior"
    ]
  },
  "EMOH - Emirates Ministry of Health Dubai": {
    "Doctors": [
      "Anesthesia",
      "Anatomic Pathology",
      "Cardiology",
      "Cardiothoracic Surgery",
      "Clinical Pathology",
      "Community Medicine",
      "Dermatology",
      "Diagnostic Radiology",
      "Emergency Medicine",
      "Family Medicine",
      "Forensic Medicine",
      "Gastroenterology",
      "General Practitioner",
      "General Surgery",
      "Hematology and Oncology",
      "Intensive Care",
      "Internal Medicine",
      "Nephrology",
      "Neurosurgery",
      "Obstetrics & Gynaecology",
      "Ophthalmology",
      "Orthopedics",
      "Otolaryngology",
      "Pediatrics",
      "Physical Medicine and Rehabilitation",
      "Plastic Surgery",
      "Psychiatry",
      "Pulmonology",
      "Urology",
      "Vascular Surgery"
    ],
    "Dentistry": [
      "Dental Assistant",
      "Dental Hygiene",
      "Dental Lab Tech",
      "Endodontic",
      "General Dentistry",
      "Implantology",
      "Oral Maxillofacial Surgery",
      "Orthodontics",
      "Pedodontics"
    ],
    "Pharmacy": [
      "Pharmacist",
      "Assistant Pharmacists"
    ],
    "Allied Health": [
      "Anesthesia Technician",
      "Ayurveda Practitioner",
      "Biomedical Technology Specialist",
      "Biomedical Technology Technician",
      "Biochemistry Technician",
      "Biochemistry Technologies",
      "Cardiac Perfusion",
      "Clinical Nutrition",
      "Electro Cardiology",
      "Emergency Med Technician",
      "Homeopathy",
      "Lab Tech",
      "Medical Lab Technician",
      "Medical Lab Technology",
      "Medical Microbiology",
      "Medical Record – Arabic",
      "Microbiology",
      "Occupational Therapy",
      "Optometrist",
      "Orthotics & Prosthetics Technician",
      "Physiotherapist",
      "Physiotherapy Technician",
      "Psychology",
      "Radiographer",
      "Radiology",
      "Radiology Tech",
      "Renal Dialysis Technician",
      "Respiratory Technician",
      "Sterilization Specialist"
    ]
  },
};
export const doctorsExams =
  examNamesByCategory["DHA - Dubai Health Authority"].Doctors;
export const pharmacistExams =
  examNamesByCategory["DHA - Dubai Health Authority"].Pharmacist;
export const dentistExams =
  examNamesByCategory["DHA - Dubai Health Authority"].Dentist;
export const nurseExams =
  examNamesByCategory["DHA - Dubai Health Authority"].Nurse;
export const physiotherapyExams =
  examNamesByCategory["DHA - Dubai Health Authority"].Physiotherapy;
export const technicianExams =
  examNamesByCategory["DHA - Dubai Health Authority"].Technician;

// Exam Fees Structure - $130 USD per exam for all specialties
export const examFeesBySpecialty = {
  "Doctors": {
    "Anesthesia": 130,
    "Anatomic Pathology": 130,
    "Cardiology": 130,
    "Cardiothoracic Surgery": 130,
    "Clinical Pathology": 130,
    "Community Medicine": 130,
    "Dermatology": 130,
    "Diagnostic Radiology": 130,
    "Emergency Medicine": 130,
    "Family Medicine": 130,
    "Forensic Medicine": 130,
    "Gastroenterology": 130,
    "General Practitioner": 130,
    "General Surgery": 130,
    "Hematology and Oncology": 130,
    "Intensive Care": 130,
    "Internal Medicine": 130,
    "Nephrology": 130,
    "Neurosurgery": 130,
    "Obstetrics & Gynaecology": 130,
    "Ophthalmology": 130,
    "Orthopedics": 130,
    "Otolaryngology": 130,
    "Pediatrics": 130,
    "Physical Medicine and Rehabilitation": 130,
    "Plastic Surgery": 130,
    "Psychiatry": 130,
    "Pulmonology": 130,
    "Urology": 130,
    "Vascular Surgery": 130
  },
  "Dentistry": {
    "Dental Assistant": 130,
    "Dental Hygiene": 130,
    "Dental Lab Tech": 130,
    "Endodontic": 130,
    "General Dentistry": 130,
    "Implantology": 130,
    "Oral Maxillofacial Surgery": 130,
    "Orthodontics": 130,
    "Pedodontics": 130
  },
  "Pharmacy": {
    "Pharmacist": 130,
    "Assistant Pharmacists": 130
  },
  "Allied Health": {
    "Anesthesia Technician": 130,
    "Ayurveda Practitioner": 130,
    "Biomedical Technology Specialist": 130,
    "Biomedical Technology Technician": 130,
    "Biochemistry Technician": 130,
    "Biochemistry Technologies": 130,
    "Cardiac Perfusion": 130,
    "Clinical Nutrition": 130,
    "Electro Cardiology": 130,
    "Emergency Med Technician": 130,
    "Homeopathy": 130,
    "Lab Tech": 130,
    "Medical Lab Technician": 130,
    "Medical Lab Technology": 130,
    "Medical Microbiology": 130,
    "Medical Record – Arabic": 130,
    "Microbiology": 130,
    "Occupational Therapy": 130,
    "Optometrist": 130,
    "Orthotics & Prosthetics Technician": 130,
    "Physiotherapist": 130,
    "Physiotherapy Technician": 130,
    "Psychology": 130,
    "Radiographer": 130,
    "Radiology": 130,
    "Radiology Tech": 130,
    "Renal Dialysis Technician": 130,
    "Respiratory Technician": 130,
    "Sterilization Specialist": 130
  }
};

// Standard exam fee constant - All exams are $130 USD
export const STANDARD_EXAM_FEE = 130;
